module.exports = __webpack_public_path__ + "placeholder-b4d026391c451ca6271117f87c61ff73.png";


//////////////////
// WEBPACK FOOTER
// ./assets/placeholder.png
// module id = 1062
// module chunks = 0 1 2